import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { PanelDirective } from '../../directives/panel.directive';
import { TranslatePipe } from '../../filters/translate.pipe';
import { CardCreatedSurveysComponent } from '../../components/card-created-surveys/card-created-surveys.component';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import RoutingService from '../../services/routing.service';
import Session from '../../utils/session.service';

@Component({
	standalone: true,
	selector: 'compliance-assessment',
	templateUrl: './compliance-assessment.component.html',
	imports: [CommonModule, PanelDirective, CardCreatedSurveysComponent, TranslatePipe]
})
export default class ComplianceAssessmentComponent implements OnInit {
	private routingService: RoutingService = inject(RoutingService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private session: Session = inject(Session);

	vm: any = undefined;

	constructor() {
		this.vm = this;
	}

	ngOnInit() {
		this.vm.openComplianceLaunch = this.openComplianceLaunch;
		this.routingService.validateAccess('employees').then(() => {});
		this.vm.user = this.session.getSession().user;
	}

	openComplianceLaunch() {
		this.angularRoutingHelperService.setPath('/create-employee-surveys/COMPLIANCE_ASSESSMENT');
	}
}
